"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useRouteMatch = exports.useHistory = exports.useLocation = exports.useParams = exports.Redirect = exports.Switch = exports.withRouter = exports.Router = exports.Route = void 0;

var _Route = _interopRequireDefault(require("./Route"));

exports.Route = _Route.default;

var _Router = _interopRequireDefault(require("./Router"));

exports.Router = _Router.default;

var _withRouter = _interopRequireDefault(require("./withRouter"));

exports.withRouter = _withRouter.default;

var _reactRouterDom = require("react-router-dom");

exports.Switch = _reactRouterDom.Switch;
exports.Redirect = _reactRouterDom.Redirect;
exports.useParams = _reactRouterDom.useParams;
exports.useLocation = _reactRouterDom.useLocation;
exports.useHistory = _reactRouterDom.useHistory;
exports.useRouteMatch = _reactRouterDom.useRouteMatch;